import PropTypes from 'prop-types';
import {useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import CustomSelect from '../common/CustomSelect';
import CustomTextField from '../common/CustomTextField';
import {useCreateLeadCommentMutation} from '../../redux/services/leadApi';
import {getTouchpointOptions} from '../../helpers/leads';

const handleSubmit = ({
  lead, 
  createComment, 
  setComment, 
  setTouchpoint,
  setSubmitting
}) => async (e, {comment, touchpoint}) => {
  setSubmitting(true);
  let params = {lead_id: lead.id, content: comment};
  if (touchpoint) params.touchpoint = touchpoint;
  const request = await createComment(params);
  setSubmitting(false);
  if (request?.error) alert('Failed to submit comment');
  setComment('');
  setTouchpoint(null);
};

const CommentEditor = props => {
  const {lead} = props;
  const [touchpoint, setTouchpoint] = useState(null);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [createComment] = useCreateLeadCommentMutation();
  const onSubmit = handleSubmit({
    lead,
    createComment, 
    setComment,
    setTouchpoint,
    setSubmitting
  });
  return (
    <Box>
      <Stack alignItems='center'>
        <CustomSelect 
          label='Touchpoint'
          fullWidth
          placeholder='Optional Contact Method'
          value={touchpoint}
          options={getTouchpointOptions()}
          onChange={e => setTouchpoint(e.target.value)}
        />
        <CustomTextField
          fullWidth
          label='Comment'
          type='textarea'
          multiline={true}
          rows={3}
          value={comment}
          onChange={e => setComment(e.target.value)}
        />
        <Box>
          <Button
            disabled={submitting}
            onClick={e => onSubmit(e, {comment, touchpoint})}
          >
            Save Comment
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

CommentEditor.propTypes = {
  lead: PropTypes.object.isRequired,
};

export default CommentEditor;